var chunkMapping = {
	"53": [
		53
	],
	"66": [
		2066
	],
	"71": [
		7071
	],
	"105": [
		9105
	],
	"106": [
		3106
	],
	"155": [
		7155
	],
	"182": [
		2182
	],
	"325": [
		9325
	],
	"390": [
		3390
	],
	"466": [
		4466
	],
	"480": [
		480
	],
	"658": [
		2658
	],
	"687": [
		2687
	],
	"688": [
		9688
	],
	"702": [
		1702
	],
	"747": [
		2747
	],
	"862": [
		3862
	],
	"878": [
		5878
	],
	"915": [
		5915
	],
	"918": [
		1918
	],
	"976": [
		8976
	]
};
var idToExternalAndNameMapping = {
	"53": [
		"default",
		"./PaymentMethods",
		2406
	],
	"480": [
		"default",
		"./UserAssignment",
		5561
	],
	"1702": [
		"default",
		"./Coupons",
		3197
	],
	"1918": [
		"default",
		"./StoreConfig",
		7207
	],
	"2066": [
		"default",
		"./Ram",
		1645
	],
	"2182": [
		"default",
		"./StoreReception",
		320
	],
	"2658": [
		"default",
		"./IntegrationsAdmin",
		1774
	],
	"2687": [
		"default",
		"./SkuAdmin",
		9597
	],
	"2747": [
		"default",
		"./Dac",
		6379
	],
	"3106": [
		"default",
		"./Foodcoins",
		9398
	],
	"3390": [
		"default",
		"./Rps",
		3221
	],
	"3862": [
		"default",
		"./Login",
		2116
	],
	"4466": [
		"default",
		"./Navigation",
		2042
	],
	"5878": [
		"default",
		"./Services",
		361
	],
	"5915": [
		"default",
		"./SalesReport",
		1348
	],
	"7071": [
		"default",
		"./DrValidations",
		3070
	],
	"7155": [
		"default",
		"./Menu",
		1307
	],
	"8976": [
		"default",
		"./ComponentsStencil",
		5493
	],
	"9105": [
		"default",
		"./Spm",
		9215
	],
	"9325": [
		"default",
		"./Scm",
		5443
	],
	"9688": [
		"default",
		"./Nps",
		9538
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_modules__[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_modules__[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}